/**
 * 🔴 **本文件由脚本生成，请勿手工修改**（改了会在 `gen-tokens --check` 里红）
 *
 * - 生成器：`code/tools/gen-tokens.ts`
 * - 唯一输入：`docs/03-UX与UI设计/assets/tokens.css`（**设计令牌唯一来源** · 铁律 10）
 * - 生成时间不写入：**时间戳会让每次构建都产生 diff**（产物只随输入变，不随时间变）
 *
 * 为什么是生成而不是手写：移交文档 §1 与 `DR-024` ④ 明文**禁止转写成 JS 常量或第二份变量表**
 * （v1 病灶②：`app.wxss` + `theme.ts` 三处真相）。本文件是**唯一**允许存在的结构化形态，
 * 且它**不手工维护** —— 值从 CSS 递归解析而来（含 `var()` 别名展开）。
 *
 * 🆕 同源的另外两份产物（同一个生成器、同一次运行）：
 * `packages/miniprogram/styles/tokens.generated.wxss`（小程序 WXSS 变量块）
 * 与 `packages/miniprogram/styles/rpx.generated.json`（**`rpx` 映射表** · 基准宽度 390）。
 */

/** 亮色（`:root`）—— 121 个令牌，`var()` 已解析为真值 */
export const TOKENS_LIGHT = {
  'c-alert': '#C8402F',
  'c-alert-bg': '#FDF1EF',
  'c-bg': '#F6F8F7',
  'c-border': '#E2E7E5',
  'c-border-strong': '#CBD3D0',
  'c-brand': '#1F9D69',
  'c-brand-fill': '#178057',
  'c-brand-hover': '#106244',
  'c-brand-line': '#A7E5C6',
  'c-brand-weak': '#EDFAF3',
  'c-divider': '#EFF2F1',
  'c-down': '#1B7A50',
  'c-down-bg': '#EEF8F2',
  'c-info': '#3A6EA5',
  'c-info-bg': '#F0F5FA',
  'c-notice': '#B4791B',
  'c-notice-bg': '#FDF6E8',
  'c-ok': '#1B7A50',
  'c-ok-bg': '#EEF8F2',
  'c-surface': '#FFFFFF',
  'c-surface-raise': '#FFFFFF',
  'c-surface-sunk': '#EFF2F1',
  'c-text': '#16201D',
  'c-text-2': '#52605C',
  'c-text-3': '#6F7D79',
  'c-text-invert': '#FFFFFF',
  'c-up': '#C8402F',
  'c-up-bg': '#FDF1EF',
  'cat-1': '#3A6EA5',
  'cat-2': '#6BA3DC',
  'cat-3': '#7B61B5',
  'cat-4': '#8A4FA8',
  'cat-5': '#E0A33F',
  'cat-6': '#9BA8A4',
  'cat-7': '#4E9E86',
  'cat-8': '#C07A5E',
  'e-in-out': 'cubic-bezier(.4, 0, .2, 1)',
  'e-out-expo': 'cubic-bezier(.19, 1, .22, 1)',
  'e-out-quart': 'cubic-bezier(.16, 1, .3, 1)',
  'em-100': '#D2F2E2',
  'em-200': '#A7E5C6',
  'em-300': '#74D2A5',
  'em-400': '#43B983',
  'em-50': '#EDFAF3',
  'em-500': '#1F9D69',
  'em-600': '#178057',
  'em-700': '#106244',
  'em-800': '#0C4934',
  'em-900': '#093526',
  'font-display': '"Inter var", "PingFang SC", "HarmonyOS Sans SC", "Source Han Sans SC", "Noto Sans SC", "Microsoft YaHei", system-ui, -apple-system, "Segoe UI", sans-serif',
  'font-num': '"Roboto Mono", "SF Mono", "JetBrains Mono", ui-monospace, "Cascadia Mono", Consolas, monospace',
  'font-sans': '"Inter var", "PingFang SC", "HarmonyOS Sans SC", "Source Han Sans SC", "Noto Sans SC", "Microsoft YaHei", system-ui, -apple-system, "Segoe UI", sans-serif',
  'fs-11': '11px',
  'fs-12': '12px',
  'fs-13': '13px',
  'fs-14': '14px',
  'fs-15': '15px',
  'fs-16': '16px',
  'fs-18': '18px',
  'fs-20': '20px',
  'fs-24': '24px',
  'fs-28': '28px',
  'fs-34': '34px',
  'fs-42': '42px',
  'fs-hero': 'clamp(34px, 4.4vw, 52px)',
  'fw-400': '400',
  'fw-500': '500',
  'fw-600': '600',
  'fw-700': '700',
  'gap-grid': 'clamp(12px, 1.2vw, 18px)',
  'lh-base': '1.6',
  'lh-loose': '1.75',
  'lh-snug': '1.4',
  'lh-tight': '1.2',
  'ls-num': '-0.01em',
  'ls-tight': '-0.02em',
  'maxw': '1320px',
  'n-0': '#FFFFFF',
  'n-100': '#EFF2F1',
  'n-200': '#E2E7E5',
  'n-25': '#FBFCFB',
  'n-300': '#CBD3D0',
  'n-400': '#9BA8A4',
  'n-50': '#F6F8F7',
  'n-500': '#6F7D79',
  'n-600': '#52605C',
  'n-700': '#3A4744',
  'n-800': '#242F2C',
  'n-900': '#16201D',
  'n-950': '#0D1614',
  'pad-card': 'clamp(16px, 1.6vw, 22px)',
  'pad-page': 'clamp(16px, 2.2vw, 32px)',
  'r-full': '999px',
  'r-lg': '14px',
  'r-md': '10px',
  'r-sm': '6px',
  'r-xl': '20px',
  'r-xs': '4px',
  'sh-1': '0 1px 2px rgba(13, 22, 20, .05)',
  'sh-2': '0 2px 8px -2px rgba(13, 22, 20, .08), 0 1px 2px rgba(13, 22, 20, .04)',
  'sh-3': '0 8px 24px -6px rgba(13, 22, 20, .12), 0 2px 6px -2px rgba(13, 22, 20, .06)',
  'sh-4': '0 20px 48px -12px rgba(13, 22, 20, .20), 0 4px 12px -4px rgba(13, 22, 20, .08)',
  'sh-focus': '0 0 0 3px rgba(31, 157, 105, .22)',
  'sidebar-w': '228px',
  'sidebar-wc': '64px',
  'sp-1': '4px',
  'sp-10': '40px',
  'sp-12': '48px',
  'sp-16': '64px',
  'sp-2': '8px',
  'sp-20': '80px',
  'sp-3': '12px',
  'sp-4': '16px',
  'sp-5': '20px',
  'sp-6': '24px',
  'sp-8': '32px',
  't-base': '220ms',
  't-fast': '130ms',
  't-slow': '380ms',
  'topbar-h': '58px',
  'touch-min': '44px',
} as const;

/** 暗色（`[data-theme="dark"]`）—— 41 个**覆盖项**（未覆盖的沿用亮色） */
export const TOKENS_DARK_OVERRIDES = {
  'c-alert': '#EB6A57',
  'c-alert-bg': '#2A1714',
  'c-bg': '#0D1614',
  'c-border': '#253430',
  'c-border-strong': '#33443F',
  'c-brand': '#43B983',
  'c-brand-fill': '#43B983',
  'c-brand-hover': '#5AC894',
  'c-brand-line': '#1F4A38',
  'c-brand-weak': '#122A21',
  'c-divider': '#1E2B28',
  'c-down': '#43B983',
  'c-down-bg': '#11291F',
  'c-info': '#6BA3DC',
  'c-info-bg': '#14202B',
  'c-notice': '#E0A33F',
  'c-notice-bg': '#2A2113',
  'c-ok': '#43B983',
  'c-ok-bg': '#11291F',
  'c-surface': '#14201D',
  'c-surface-raise': '#1A2724',
  'c-surface-sunk': '#0D1614',
  'c-text': '#ECF2EF',
  'c-text-2': '#A3B2AD',
  'c-text-3': '#7C8B86',
  'c-text-invert': '#0D1614',
  'c-up': '#EB6A57',
  'c-up-bg': '#2A1714',
  'cat-1': '#5E93D0',
  'cat-2': '#8FBCE8',
  'cat-3': '#9B85CE',
  'cat-4': '#A96FC0',
  'cat-5': '#E8B45E',
  'cat-6': '#A9B6B2',
  'cat-7': '#64B79C',
  'cat-8': '#D0967C',
  'sh-1': '0 1px 2px rgba(0, 0, 0, .4)',
  'sh-2': '0 2px 8px -2px rgba(0, 0, 0, .5), 0 1px 2px rgba(0, 0, 0, .3)',
  'sh-3': '0 8px 24px -6px rgba(0, 0, 0, .6), 0 2px 6px -2px rgba(0, 0, 0, .4)',
  'sh-4': '0 20px 48px -12px rgba(0, 0, 0, .7), 0 4px 12px -4px rgba(0, 0, 0, .5)',
  'sh-focus': '0 0 0 3px rgba(67, 185, 131, .28)',
} as const;

/** 亮色令牌名（供 `--check` 与测试断言用） */
export const TOKEN_NAMES_LIGHT = [
  'c-alert',
  'c-alert-bg',
  'c-bg',
  'c-border',
  'c-border-strong',
  'c-brand',
  'c-brand-fill',
  'c-brand-hover',
  'c-brand-line',
  'c-brand-weak',
  'c-divider',
  'c-down',
  'c-down-bg',
  'c-info',
  'c-info-bg',
  'c-notice',
  'c-notice-bg',
  'c-ok',
  'c-ok-bg',
  'c-surface',
  'c-surface-raise',
  'c-surface-sunk',
  'c-text',
  'c-text-2',
  'c-text-3',
  'c-text-invert',
  'c-up',
  'c-up-bg',
  'cat-1',
  'cat-2',
  'cat-3',
  'cat-4',
  'cat-5',
  'cat-6',
  'cat-7',
  'cat-8',
  'e-in-out',
  'e-out-expo',
  'e-out-quart',
  'em-100',
  'em-200',
  'em-300',
  'em-400',
  'em-50',
  'em-500',
  'em-600',
  'em-700',
  'em-800',
  'em-900',
  'font-display',
  'font-num',
  'font-sans',
  'fs-11',
  'fs-12',
  'fs-13',
  'fs-14',
  'fs-15',
  'fs-16',
  'fs-18',
  'fs-20',
  'fs-24',
  'fs-28',
  'fs-34',
  'fs-42',
  'fs-hero',
  'fw-400',
  'fw-500',
  'fw-600',
  'fw-700',
  'gap-grid',
  'lh-base',
  'lh-loose',
  'lh-snug',
  'lh-tight',
  'ls-num',
  'ls-tight',
  'maxw',
  'n-0',
  'n-100',
  'n-200',
  'n-25',
  'n-300',
  'n-400',
  'n-50',
  'n-500',
  'n-600',
  'n-700',
  'n-800',
  'n-900',
  'n-950',
  'pad-card',
  'pad-page',
  'r-full',
  'r-lg',
  'r-md',
  'r-sm',
  'r-xl',
  'r-xs',
  'sh-1',
  'sh-2',
  'sh-3',
  'sh-4',
  'sh-focus',
  'sidebar-w',
  'sidebar-wc',
  'sp-1',
  'sp-10',
  'sp-12',
  'sp-16',
  'sp-2',
  'sp-20',
  'sp-3',
  'sp-4',
  'sp-5',
  'sp-6',
  'sp-8',
  't-base',
  't-fast',
  't-slow',
  'topbar-h',
  'touch-min',
] as const;
